import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/sharp-regular-svg-icons";
import styles from "./page.module.scss";

type PageProps = {
  // back?:
  //   | string
  //   | {
  //       route: string;
  //       options: NavigateOptions;
  //     };
  // hasMenuButton?: boolean;
  title: string;
};

export default function Page({
  title,
  children,
}: PropsWithChildren<PageProps>) {
  const navigate = useNavigate();

  return (
    <div className={styles.pageRoot}>
      <div className={styles.pageHeader}>
        <button type="button" onClick={() => navigate("/")}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        {title}
      </div>
      {children}
    </div>
  );
}
